import { isNilOrEmpty, dotPath } from 'ramdasauce'
import cn from 'classnames'

import { useStyles } from './styles'
import { Text, SanityButton, Animated } from 'components/atoms'

export const TextSection = ({ data }) => {
  const classes = useStyles()

  const wrapperClasses = cn({
    [classes.wrapper]: true,
    [classes.yellow]: dotPath('backgroundColor', data),
  })
  const titleClasses = cn({
    [classes.title]: true,
    [classes.noBodyTitle]: isNilOrEmpty(data.paragraph),
  })

  const renderButtons = (data) =>
    data.map((button, i) => {
      return (
        <div key={i} className={classes.buttonContainer}>
          <SanityButton data={button} round />
        </div>
      )
    })

  return (
    <div className={wrapperClasses}>
      <div className={classes.container}>
        <Animated type="fade-in">
          {!isNilOrEmpty(data.title) && (
            <div className={titleClasses}>
              <Text tag="h3" size="header9">
                {data.title}
              </Text>
            </div>
          )}
          {!isNilOrEmpty(data.paragraph) && (
            <div className={classes.body}>
              <Text tag="p" size="body18">
                {data.paragraph}
              </Text>
            </div>
          )}
          {!isNilOrEmpty(dotPath('ctaButtons', data)) && (
            <div className={classes.buttonWrapper}>
              {renderButtons(data.ctaButtons)}
            </div>
          )}
        </Animated>
      </div>
    </div>
  )
}
